import { SizeScreen, SourceAbbr, SourceName } from "../enums";

export const isMobileScreen = (): boolean => window.innerWidth <= SizeScreen.MOBILE;
export const isSourceFordPass = (source: string): boolean => source === SourceName.fordpass || source === SourceAbbr.fordpass;
export const isSourcePerks = (source: string) => SourceName.perks === source;
export const isSourceWeb = (source: string) => SourceName.web === source;
export const isSourceMobile = (source: string) => SourceName.mobile === source;
export const getSourceCode = (value: string) => Object.entries(SourceAbbr).find(([key]) => key === value)?.[1];
